export const calculateGameStats = (gameData) => {
    if (!gameData?.plays?.length) return null;
    const lastPlay = gameData.plays[gameData.plays.length - 1];
    const homeScore = lastPlay?.home_score_after || 0;
    const awayScore = lastPlay?.away_score_after || 0;
    const biggestPlay = [...gameData.plays].sort((a, b) => Math.abs(b.wpa) - Math.abs(a.wpa))[0];
    const playerWPA = gameData.plays.reduce((acc, play) => {
      if (play.batter_name) acc[play.batter_name] = (acc[play.batter_name] || 0) + (play.wpa || 0);
      if (play.pitcher_name) acc[play.pitcher_name] = (acc[play.pitcher_name] || 0) - (play.wpa || 0);
      return acc;
    }, {});
    const mvp = Object.entries(playerWPA).sort((a, b) => b[1] - a[1])[0];
    let leadChanges = 1;
    let lastLeader = null;
    gameData.plays.forEach((play) => {
      const currentLeader = play.home_score_after > play.away_score_after ? "home" : play.away_score_after > play.home_score_after ? "away" : "tie";
      if (lastLeader && currentLeader !== "tie" && currentLeader !== lastLeader) leadChanges++;
      if (currentLeader !== "tie") lastLeader = currentLeader;
    });
    
    // Leverage-Weighted Excitement Index
    // EI_LI = Σ |WE_i - WE_{i-1}| × LI_i
    const rawExcitementIndex = gameData.plays.reduce((sum, play) => {
      const wpaAbs = Math.abs(play.wpa || 0);
      const li = play.li || 1;
      return sum + (wpaAbs * li);
    }, 0);
    
    const maxExcitement = 20;
    const excitementIndex = Math.min(100, Math.round((rawExcitementIndex / maxExcitement) * 100));
    
    return { homeScore, awayScore, biggestPlay, mvp, leadChanges, excitementIndex };
  };